export const PAGE_LIMIT = 100;
export const PARAMS = [["r","Revenues"],["oR","Onw Revenues"],["tR","Total Revenues"],["sp","Spends"],["c","Conversions"],["ro","Clicks Roi", 'roi'],["oRo","Onw Roi", 'roi'],["tRo","Roi", 'roi'],["tPRo","Roi %", 'roi'],["cP","Conversions Price"]];


// WEBPACK FOOTER //
// ./src/scenes/AdKernelDaily/config.js